import request from '@/utils/request'

// 查询会员风采展示列表
export function noPermissionList(query) {
  return request({
    url: '/system/memberStyle/noPermissionList',
    method: 'get',
    params: query
  })
}


// 查询产品详细
export function noPermission(id) {
  return request({
    url: '/system/memberStyle/noPermission/' + id,
    method: 'get'
  })
}
